module.exports = __webpack_public_path__ + "media/images/www/company/shipment-give-66c667c96c8308ab756d200d0a47dd20.svg";